import request from "~/utils/http";

const reportApi = {
    revenue: async (params) =>
    {
        const url = 'report/revenue';
        return await request.get(url, { params });
    },

    revenueByUser: async (params) =>
    {
        const url = 'report/revenue-by-user';
        return await request.get(url, { params });
    },

    revenueByProduct: async (params) =>
    {
        const url = 'report/revenue-by-product';
        return await request.get(url, { params });
    },
};

export default reportApi;
